import React, { useState } from 'react';

// The Shiven brand logo is managed in the landing admin (Admin > Profile) and
// served from one stable URL. Falls back to the bundled logo if it can't load.
export const BRAND_LOGO_URL =
  process.env.REACT_APP_BRAND_LOGO_URL || 'https://shivenclinic.com/api/settings/logo';
export const BUNDLED_LOGO = '/img/logo.png';

export default function BrandLogo({ alt = 'Shiven Clinic', fallback = BUNDLED_LOGO, ...props }) {
  const [src, setSrc] = useState(BRAND_LOGO_URL);
  return (
    <img
      {...props}
      src={src}
      alt={alt}
      onError={() => {
        if (src !== fallback) setSrc(fallback);
      }}
    />
  );
}
